import React from 'react'
import { Button, DialogueBox } from 'components/UIElements'
import { replaceInString } from 'utils/misc'

const ConsentIntroductionView = ({
  strings,
  firstName,
  onStartConsent,
  humiIsabellaDisabled
}) => {
  return (
    <DialogueBox className='dialogue has-humi' hasHumi={!humiIsabellaDisabled}>
      <h3>{replaceInString(strings.welcome_user, '[Name]', firstName)}</h3>
      <p>{strings.intro_humi}</p>
      <p>{strings.intro_consent_desc}</p>
      <Button
        primary
        className='start-consent-btn'
        content={strings.start_consent}
        onClick={onStartConsent}
        type='button'
      />
    </DialogueBox>
  )
}

export default ConsentIntroductionView
